import { render, staticRenderFns } from "./TestimonialItem.vue?vue&type=template&id=7c121fe6&scoped=true&"
import script from "./TestimonialItem.vue?vue&type=script&lang=js&"
export * from "./TestimonialItem.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialItem.vue?vue&type=style&index=0&id=7c121fe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c121fe6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VIcon})
